import React from 'react';
import { Globe, Headphones, Phone, Users } from 'lucide-react';

export const Stats = () => {
  const stats = [
    {
      icon: Headphones,
      value: "10,000+",
      label: "Entreprises accompagnées",
      iconColor: "text-primary",
    },
    {
      icon: Users,
      value: "250,000+",
      label: "Utilisateurs actifs",
      iconColor: "text-tertiary",
    },
    {
      icon: Phone,
      value: "5M+",
      label: "Appels traités chaque mois",
      iconColor: "text-primary",
    },
    {
      icon: Globe,
      value: "20+",
      label: "Pays couverts",
      iconColor: "text-tertiary",
    },
  ];

  return (
    <section className="py-2 px-6 lg:px-12 max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl border border-slate-100/80 shadow-sm py-4 px-4 grid grid-cols-2 md:grid-cols-4 gap-4 divide-y md:divide-y-0 md:divide-x divide-slate-100">
        {stats.map((stat, index) => {
          const Icon = stat.icon;
          return (
            <div 
              key={index} 
              className={`flex flex-col items-center justify-center ${index > 0 ? 'pt-3 md:pt-0' : ''}`}
            >
              <div className="flex items-center gap-2 mb-0.5">
                <Icon className={stat.iconColor} size={18} />
                <span className="text-lg lg:text-xl font-extrabold text-primary">
                  {stat.value}
                </span>
              </div>
              <span className="text-[11px] text-slate-500 font-medium text-center">
                {stat.label}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
};